// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchButton_icon__JwKSG"};